<template>
  <div id="exhpredictionList">
    <div id="tableView" v-loading="this.loading" element-loading-text="加载中">
			<el-row>
        <el-form label-width="75px" :inline="true" class="el-form demo-form-inline">
          <el-row>
            <el-col :span="12" class="searchInline">
              <label class="el-form-item__label searchLabel">批语内容</label>
              <el-input size="small" v-model="searchForm.pynr" placeholder="批语内容" clearable></el-input>
            </el-col>
          </el-row>
          <div>
            <el-form>
              <el-col :span="12" class="btnEditDelete">
                <el-form-item align="left">
                  <el-button type="success" icon="el-icon-plus" size="small" @click="addClick">新增</el-button>
                  <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteClick">删除</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="btnSearchPlus">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" size="small" @click="searchClick">查询</el-button>
                  <el-button type="clear" icon="el-icon-refresh" size="small" @click="clearClick">重置</el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-form>
      </el-row>
			<div class="table_container">
        <el-table class="tableStyle" border id="table" :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" @selection-change="selectionChange"
          :height="tableheight" tooltip-effect="dark" :row-style="rowStyle">
          <el-table-column type="selection" width="35"></el-table-column>
          <el-table-column type="index" label="序号" show-overflow-tooltip width="65" align="center"></el-table-column>
          <el-table-column prop="pynr" label="批语内容" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column label="操作" width="75" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--翻页组件-->
        <el-row type="flex" justify="end">
          <paginator v-if="tableData.length>0"></paginator>
        </el-row>
			</div>


      <!-- 批语 -->
      <el-dialog :title="title" :visible.sync="open" :close-on-click-modal="false">
        <el-form :model="form" label-width="130px" :rules="rules" ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="pynr" label="批语内容">
                <el-input type="textarea" :autosize="{minRows:3}" maxlength="200" size="small" v-model="form.pynr" placeholder="批语内容" clearable></el-input>
              </el-form-item>
              <el-row style="margin-top: -15px;margin-bottom: 15px;text-align:right">
                <div class="el-upload__tip">最大可输入<font style="color:red">{{ 200 }}</font>个字，还可输入
                  <span style="color: red" id="cgmsLength">{{200-(form.pynr != null ? form.pynr.length : 0) >= 0 ? 200-(form.pynr != null ? form.pynr.length : 0) : 0}}</span>个字
                </div>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <el-row class="buttonSubmit">
          <el-button type="clear" icon="el-icon-close" size="small" @click="closeDialog">取消</el-button>
          <el-button type="success" icon="el-icon-check" size="small" @click="save">保存</el-button>
        </el-row>
      </el-dialog>
		</div>
  </div>
</template>
<script>
//引入翻页 paginator
import paginator from '@/components/paginator'
export default {
  components: {
    paginator
  },
  data() {
    return {
      //当前登陆用户
      currentUser: this.CONSTANT.currentUser,
      //搜索表单
      searchForm: {
        pynr: ""
      },
      that: this,
      tableData: [],
      //表高度变量
      tableheight: this.CONSTANT.tableheight10,
      //多选值
      multipleSelection: [],
      //显示加载中样
      loading: false,
      //当前页
      currentPage: 1,
      //分页大小
      pageSize: 10,
      //总记录数
      total: 0,
      form: {
        pynr: ""
      },
      rules: {
        pynr: [
          { required: true, message: "请输入批语内容", trigger: "blur" },
          {
            max: 200,
            message: "企业名称最多为200字符",
            trigger: "blur"
          }
        ],
      },
      open: false,
      title: "",
    };
  },
  created () {
    if(this.$store.state.listPagePars.has(this.$route.path)){
        this.searchForm = this.$store.state.listPagePars.get(this.$route.path);
        this.currentPage = this.searchForm.pageNum;
        this.pageSize = this.searchForm.pageSize;
      }
    this.searchClick('page');
  },
  filters: {
  },
  methods: {
    //表格查询事件
    searchClick (type) {
      let vm = this;
      this.tableData = [];
      if (type != 'page') {
        this.currentPage = 1;
      }
      vm.loading = true;//表格重新加载
      var params = {
        pynr_like: vm.searchForm.pynr,
        userid: vm.currentUser.userid,
        pageSize: vm.pageSize,
        pageNum: vm.currentPage
      }
      vm.$axios.post('/cfpapy/page', params).then(function (res) {
        var tableTemp = new Array((vm.currentPage-1)*vm.pageSize);
        vm.tableData = tableTemp.concat(res.data.result.list);
        this.total = res.data.result.total;
        this.loading = false;

        this.$store.dispatch('saveListPagePars', {path: this.$route.path, pars: params});
      }.bind(this), function (error) {
        console.log(error)
      })
    },

    //清空查询条件
    clearClick () {
      this.searchForm.pynr = '';
      this.searchClick('reset');
    },

    //表格勾选事件
    selectionChange (val) {
      this.multipleSelection = val;
    },

    //新增事件
    addClick: function() {
      this.form = {
        pynr: "",
      }
      this.title = "新增批语内容"
      this.open = true
    },

    //关闭Dialog
    closeDialog () {
      this.$refs["form"].resetFields();
      this.open = false;
    },

    //表格修改事件
    editClick: function(val, index) {
      this.$axios.get("cfpapy/" + val.uuid).then(res => {
        if (res.data.code == "00000000") {
          this.form = res.data.result
          this.title = "编辑批语内容"
          this.open = true
        }
      })
    },
     //删除所选，批量删除
    deleteClick: function() {
      this.$confirm('确定删除已选中批语?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let vm = this;
        for (var i in this.multipleSelection) {
          vm.multipleSelection[i].xgrid = this.currentUser.userid;
          vm.multipleSelection[i].xgrmc = this.currentUser.username;
          vm.multipleSelection[i].deleteFlag = 'Y';
        }
        vm.$axios.post('/cfpapy/doDeletePyList', vm.multipleSelection).then(function (res) {
          vm.$message({
            message: "成功删除" + res.data.result + "条批语",
            showClose: true,
            onClose: this.searchClick('delete')
          });
        }.bind(this), function (error) {
          console.log(error)
        })
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },


    // 保存
    save () {
      this.$refs["form"].validate((valid) => {
        if(valid) {
          if (!this.form.uuid) {
            this.form.cjrid = this.currentUser.userid;
            this.form.userid = this.currentUser.userid;
            this.form.cjrmc = this.currentUser.username;
            this.$axios.post("/cfpapy", this.form).then(res => {
              if (res.data.code == "00000000") {
                this.$message.success("新增成功")
                this.open = false
                this.searchClick("add")
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error("新增失败")
            })
          } else {
            this.form.xgrid = this.currentUser.userid;
            this.form.xgrmc = this.currentUser.username;
            this.$axios.put("/cfpapy", this.form).then(res => {
              if (res.data.code == "00000000") {
                this.$message.success("编辑成功")
                this.open = false
                this.searchClick("page")
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error("编辑失败")
            })
          }
        }
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/Approval/commentary.vue